<account-not-verify-form
  (navigateToSignupVerify)="navigateToSignupVerify()"
  [appName]="appName"
></account-not-verify-form>